export default function alumniReducer(state = {}, _) {
  return state;
}
